'use client';

import { createContext } from 'react';

// Holds server-fetched getModularSofaBundle data (keyed by slug, no location
// variables) so the server-side useSuspenseQuery in useModularPDPState is
// skipped, stopping the ~7 MB per-render re-fetch on modular PDP pages.
// Default undefined = no provider in tree (falls through to Apollo).
// NOTE: data has no zipCode/stateCode, so meta.price reflects national defaults.
// Client-side Apollo still fires with full location variables after hydration.
const ModularSofaBundleContext = createContext(undefined);

export default ModularSofaBundleContext;
